import { CaretLeft, type IconProps } from "@phosphor-icons/react";

export function ChevronLeftIcon(props: IconProps) {
  return <CaretLeft size={24} weight="regular" {...props} />;
}
